module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_order_product-83bb47cc1c47122c6ba2b2d24b2fdcb0.png";